<template>
  <div class="menu-mobile" @click="$emit('close')">
    <div class="menu-content">
      <div
        class="menu-item"
        v-for="(navItem, index) in mobileDropDownList"
        :key="index"
      >
        <div
          class="menu-item-title d-flex ai-center jc-center"
          @click.stop="onNavItem(navItem)"
        >
          <img class="icon" v-if="navItem.icon" :src="navItem.icon" />
          <div>{{ navItem.title }}</div>
          <img
            class="arrow-down"
            :class="{ active: navItem.isShow }"
            v-if="navItem.children"
            src="../assets/images/enter-on.png"
          />
        </div>
        <div class="nav-item-list-box" v-if="navItem.isShow">
          <div
            class="nav-item-list"
            v-for="(langItem, index) in navItem.children"
            :key="index"
            @click.stop="onNavChildItem(langItem)"
          >
            <div
              class="text title d-flex ai-center jc-center"
              :data-lang="langItem.lang"
            >
              {{ langItem.langText }}
            </div>
            <div :class="{ line: index !== navItem.children.length - 1 }"></div>
          </div>
        </div>
        <!-- <div
          :class="{
            line: index !== mobileDropDownList.length - 1 && !navItem.isShow,
          }"
        ></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileDropDownList: [
        // {
        //   title: 'Github',
        //   url: 'http',
        // },
        // {
        //   title: 'Download',
        // },
        {
          title: this.$t('contactUs'),
          isShow: false,
          children: [
            {
              langText: this.$t('officialWebsite'),
              url: 'https://tokenpocket.pro/',
            },
            {
              langText: this.$t('twitter'),
              url: 'https://twitter.com/TokenPocket_TP',
            },
            {
              langText: this.$t('telegram'),
              url: 'https://t.me/tokenpocket_channel',
            },
          ],
        },
        {
          title: this.$t('language'),
          isShow: false,
          children: [
            { langText: '简体', lang: 'zh' },
            { langText: '繁體', lang: 'zh-tw' },
            { langText: 'English', lang: 'en' },
          ],
        },
        {
          title: this.$t('getTestnetZETA'),
          url: 'https://labs.zetachain.com/get-zeta',
        },
      ],
    };
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    // 监听，除了点击自己，点击其他地方将自身隐藏
    // document.addEventListener('click', this.onOutside)
  },
  methods: {
    onOutside(e) {
      const languageBtn = this.$refs.languageBtn;
      if (!languageBtn.contains(e.target)) {
        const contentWrap = document.querySelector('.menu-content');
        if (contentWrap) {
          if (!contentWrap.contains(e.target)) {
            this.isShowLanguageBox = false;
            this.isShowLanguageListBox = false;
          }
        }
      }
    },
    onNavItem(navItem) {
      // console.log('navItem', navItem);
      if (navItem.url) {
        window.open(navItem.url, '_self');
      } else if (navItem.children) {
        navItem.isShow = !navItem.isShow;
      } else if (navItem.title === 'Download') {
        this.$emit('showMenuMobile');
      }
    },
    onNavChildItem(child) {
      // console.log('child', child);
      if (child.lang) {
        this.$i18n.locale = child.lang;
      } else if (child.url) {
        window.open(child.url, '_self');
      }
      this.$emit('close');
    },
    onChangeLang(e) {
      // this.$store.commit('changeLanguage', e.target.dataset.lang)
      if (e.target.dataset.lang) {
        console.log('e', e.target.dataset.lang);
      }
    },
    openUrl(url, index) {
      if (index === 1) {
        window.open(url, '_self');
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-mobile {
  position: fixed;
  z-index: 9997;
  top: 1rem;
  left: 0;
  width: 100vw;
  height: calc(100vh - 1rem);
  background: rgba(0, 0, 0, 0.5);
  .menu-content {
    width: 100vw;
    background: #fff;
    padding: 0.32rem 0;
    .menu-item {
      color: #333;
      font-size: 0.24rem;
      .menu-item-title {
        height: 0.99rem;
        font-size: 0.28rem;
        // font-family: Poppins-Semibold;
        font-family: Poppins-Medium;
        color: #2a2a2a;
        .icon {
          margin-right: 0.07rem;
          width: 0.26rem;
          height: 0.26rem;
        }
        .arrow-down {
          transform-origin: center center;
          transform: rotate(0);
          width: 0.32rem;
          height: 0.32rem;
          transition: all 0.2s;
          &.active {
            transform: rotate(90deg);
          }
        }
      }
      .line {
        width: 94vw;
        margin: 0 auto;
        height: 0.01rem;
        background: #d7d7d7;
      }
      .nav-item-list-box {
        background: #f5f5f5;
        .nav-item-list {
          .title {
            height: 0.99rem;
            text-align: center;
            font-size: 0.26rem;
            color: #2a2a2a;
          }
          .line {
            background: #fff;
          }
        }
      }
    }
  }
}
</style>
